import clsx from 'clsx'

export function GradientGlow({ className }: { className?: string }) {
  return (
    <div className={clsx('blur-[231px] w-[323vw] aspect-4/3 bg-orange rounded-full', className)} />
  )
}
